module.exports = {
	server: "https://dev.wearemothership.com/api/v1",
	masterKey: "sQPqWAvI9qyLvMT84Tkf"
};
